export enum authMode {
  loneAuth = 1,
  cascadeAuth = 2
}
export const AuthLabel: Record<authMode, string> = {
  [authMode.loneAuth]: '独立授权',
  [authMode.cascadeAuth]: '级联授权'
}
export const terminalInfo = {
  /** linux终端数 */
  linux_num: "linux终端",
  /** mac 终端数 */
  // mac_num: "mac 终端",
  /** windows终端数 */
  windows_num: "windows终端",
  /** windows server终端数 */
  windows_server_num: "windows server终端"
}
